import React, { Component, useRef } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import sidebarLogo from "../assets/images/logo.jpeg";
import { useSelector } from "react-redux";
import { useWhatsAppNotifications } from "../context/WhatsAppNotificationContext";

function WhatsAppSidebarLink() {
    const { unreadCount } = useWhatsAppNotifications();

    return (
        <li className="nav-item">
            <NavLink to="/whatsapp-inbox" className="nav-link">
                <i className={"ri-whatsapp-line"} style={{ fontSize: 16 }}></i>
                <span>WhatsApp</span>
                {unreadCount > 0 && (
                    <span className="sidebar-nav-badge ms-auto">
                        {unreadCount > 99 ? "99+" : unreadCount}
                    </span>
                )}
            </NavLink>
        </li>
    );
}

function DiscountsNavLink() {
    const { pathname } = useLocation();
    const discountsActive = pathname.startsWith("/offers") || pathname.startsWith("/referral-discounts");
    return (
        <NavLink to="/offers" className={() => `nav-link${discountsActive ? " active" : ""}`}>
            <i className="ri-gift-line"></i> <span>Discounts</span>
        </NavLink>
    );
}

export default function Sidebar() {
    const scrollBarRef = useRef();
    const user = useSelector(state => state.user);

    const toggleFooterMenu = (e) => {
        e.preventDefault();

        let parent = e.target.closest(".sidebar");
        parent.classList.toggle("footer-menu-show");
    }

    return (
        <div className="sidebar">
            <div className="sidebar-header">
                <Link to="/admin/dashboard" className="sidebar-logo">
                    <img src={sidebarLogo} alt="Careveli" />
                </Link>
            </div>
            <PerfectScrollbar className="sidebar-body" ref={scrollBarRef}>
                <SidebarMenu onUpdateSize={() => scrollBarRef.current?.updateScroll()} />
            </PerfectScrollbar>
            <div className="sidebar-footer">
                <div className="sidebar-footer-top">
                    <div className="sidebar-footer-thumb">
                        <img src={sidebarLogo} alt="Careveli" />
                    </div>
                    <div className="sidebar-footer-body">
                        <h6><Link onClick={toggleFooterMenu} to="" >Careveli Admin</Link></h6>
                        <p>{user?.role}</p>
                    </div>
                    <Link to="/logout" className="sidebar-logout" aria-label="Log out" title="Log out">
                        <i className="ri-logout-box-r-line"></i>
                    </Link>
                </div>
                <div className="sidebar-footer-menu">
                    <nav className="nav">
                    </nav>
                    <hr />
                    <nav className="nav">
                        <Link to="/logout"><i className="ri-logout-box-r-line"></i> Log Out</Link>
                    </nav>
                </div>
            </div>
        </div>
    )
}

class SidebarMenu extends Component {
    populateMenu = (m) => {
        const menu = m.map((m, key) => {
            let sm;
            if (m.submenu) {
                sm = m.submenu.map((sm, key) => {
                    return (
                        <NavLink to={sm.link} className="nav-sub-link" style={{ userSelect: 'none' }} key={key}>{sm.label}</NavLink>
                    )
                })
            }

            return (
                <li key={key} className="nav-item">
                    {(!sm) ? (
                        <NavLink to={m.link} className="nav-link"><i className={m.icon} style={{ fontSize: 12, paddingRight: 6 }}></i> <span style={{ userSelect: 'none' }}>{m.label}</span></NavLink>
                    ) : (
                        <div onClick={this.toggleSubMenu} className="nav-link has-sub"><i className={m.icon}></i> <span style={{ userSelect: 'none', fontSize: 12 }}>{m.label}</span></div>
                    )}
                    {m.submenu && <nav className="nav nav-sub">{sm}</nav>}
                </li>
            )
        });
        return (
            <ul className="nav nav-sidebar">
                {menu}
            </ul>
        );
    }

    // Toggle menu group
    toggleMenu = (e) => {
        e.preventDefault();

        let parent = e.target.closest('.nav-group');
        parent.classList.toggle('show');

        this.props.onUpdateSize();
    }

    // Toggle submenu while closing siblings' submenu
    toggleSubMenu = (e) => {
        e.preventDefault();

        let parent = e.target.closest('.nav-item');
        let node = parent.parentNode.firstChild;

        while (node) {
            if (node !== parent && node.nodeType === Node.ELEMENT_NODE)
                node.classList.remove('show');
            node = node.nextElementSibling || node.nextSibling;
        }

        parent.classList.toggle('show');

        this.props.onUpdateSize();
    }

    render() {
        return (
            <React.Fragment>
                {/* <div className="nav-group show">
                    <ul className="nav nav-sidebar py-0">
                        <li className="nav-item">
                            <NavLink to="" className="nav-link"><i className={"ri-home-3-line"}></i> <span style={{ userSelect: 'none' }}>Dashboard</span></NavLink>
                        </li>
                    </ul>
                </div> */}
                <div className="nav-label nav-label--static">Overview</div>
                <div className="nav-group show">
                    <ul className="nav nav-sidebar py-0">
                        <li className="nav-item">
                            <NavLink to="/admin/dashboard" className="nav-link"><i className="ri-dashboard-line"></i> <span>Dashboard</span></NavLink>
                        </li>
                    </ul>
                </div>

                <div className="nav-label nav-label--static">Catalog</div>
                <div className="nav-group show">
                    <ul className="nav nav-sidebar py-0">
                        <li className="nav-item">
                            <NavLink to="/category" className="nav-link"><i className="ri-layout-grid-line"></i> <span>Categories</span></NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/product" className="nav-link"><i className="ri-shopping-bag-3-line"></i> <span>Products</span></NavLink>
                        </li>
                    </ul>
                </div>

                <div className="nav-label nav-label--static">Sales</div>
                <div className="nav-group show">
                    <ul className="nav nav-sidebar py-0">
                        <li className="nav-item">
                            <NavLink to="/order" className="nav-link"><i className="ri-shopping-cart-2-line"></i> <span>Orders</span></NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/invoices" className="nav-link"><i className="ri-file-list-3-line"></i> <span>GST invoices</span></NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/registered" className="nav-link"><i className="ri-user-3-line"></i> <span>Customers</span></NavLink>
                        </li>
                    </ul>
                </div>

                <div className="nav-label nav-label--static">Affiliate</div>
                <div className="nav-group show">
                    <ul className="nav nav-sidebar py-0">
                        <li className="nav-item">
                            <NavLink to="/affiliate-users" className="nav-link"><i className="ri-user-star-line"></i> <span>Partners</span></NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/affiliate-commissions" className="nav-link"><i className="ri-coin-line"></i> <span>Commissions</span></NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/affiliate-withdrawals" className="nav-link"><i className="ri-wallet-3-line"></i> <span>Withdrawals</span></NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/affiliate-payouts" className="nav-link"><i className="ri-bank-card-line"></i> <span>Payouts</span></NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/marketing-links" className="nav-link"><i className="ri-links-line"></i> <span>Marketing links</span></NavLink>
                        </li>
                    </ul>
                </div>

                <div className="nav-label nav-label--static">Content</div>
                <div className="nav-group show">
                    <ul className="nav nav-sidebar py-0">
                        <li className="nav-item">
                            <NavLink to="/banner" className="nav-link"><i className="ri-image-2-line"></i> <span>Banners</span></NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/spotlight" className="nav-link"><i className="ri-video-line"></i> <span>Spotlight</span></NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/blog-editor" className="nav-link"><i className="ri-article-line"></i> <span>Blogs</span></NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/testimonial" className="nav-link"><i className="ri-chat-quote-line"></i> <span>Homepage testimonials</span></NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/reviews" className="nav-link"><i className="ri-star-line"></i> <span>Product reviews</span></NavLink>
                        </li>
                    </ul>
                </div>

                <div className="nav-label nav-label--static">Messages</div>
                <div className="nav-group show">
                    <ul className="nav nav-sidebar py-0">
                        <li className="nav-item">
                            <NavLink to="/contact" className="nav-link"><i className="ri-mail-line"></i> <span>Contact</span></NavLink>
                        </li>
                        <WhatsAppSidebarLink />
                    </ul>
                </div>

                <div className="nav-label nav-label--static">Skin Assistant</div>
                <div className="nav-group show">
                    <ul className="nav nav-sidebar py-0">
                        <li className="nav-item">
                            <NavLink to="/skin-assistant/rules" className="nav-link"><i className="ri-magic-line"></i> <span>Rules</span></NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/skin-assistant/results" className="nav-link"><i className="ri-bar-chart-grouped-line"></i> <span>Results</span></NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/skin-assistant/leads" className="nav-link"><i className="ri-contacts-book-line"></i> <span>Leads</span></NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/skin-assistant/chats" className="nav-link"><i className="ri-chat-3-line"></i> <span>Chats</span></NavLink>
                        </li>
                    </ul>
                </div>

                <div className="nav-label nav-label--static">Marketing</div>
                <div className="nav-group show">
                    <ul className="nav nav-sidebar py-0">
                        <li className="nav-item">
                            <DiscountsNavLink />
                        </li>
                        <li className="nav-item">
                            <NavLink to="/newsletter" className="nav-link"><i className="ri-mail-send-line"></i> <span>Newsletter</span></NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/payment-history" className="nav-link"><i className="ri-money-dollar-circle-line"></i> <span>Payments</span></NavLink>
                        </li>
                    </ul>
                </div>
            </React.Fragment >
        )
    }
}

window.addEventListener("click", function (e) {
    // Close sidebar footer menu when clicked outside of it
    let tar = e.target;
    let sidebar = document.querySelector(".sidebar");
    if (!tar.closest(".sidebar-footer") && sidebar) {
        sidebar.classList.remove("footer-menu-show");
    }

    // Hide sidebar offset when clicked outside of sidebar
    if (!tar.closest(".sidebar") && !tar.closest(".menu-link")) {
        document.querySelector("body").classList.remove("sidebar-show");
    }
});

window.addEventListener("load", function () {
    let skinMode = localStorage.getItem("sidebar-skin");
    let HTMLTag = document.querySelector("html");

    if (skinMode) {
        HTMLTag.setAttribute("data-sidebar", skinMode);
    }
});